import { createSlice } from "@reduxjs/toolkit";
export const eventSlice = createSlice({
    name: 'UiSlice',
    initialState: {
        notifications: [],
        notificationCount: 0,
    },
    reducers: {
        updNotification: (state, action) => {
            const payload = Array.isArray(action.payload)
                ? action.payload
                : action.payload
                ? [action.payload]
                : [];
            state.notifications = payload;
            state.notificationCount = payload.length;
        },
        prependNotifications: (state, action) => {
            const incoming = !action.payload
                ? []
                : Array.isArray(action.payload)
                ? action.payload
                : [action.payload];
            const merged = [...incoming, ...state.notifications];
            const seen = new Set();
            state.notifications = merged.filter((item) => {
                const id = item?._id;
                if (!id) return true;
                const key = String(id);
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
            state.notificationCount = state.notifications.length;
        },
    },
    //extraReducers:
})



export const { updNotification, prependNotifications } = eventSlice.actions
export default eventSlice.reducer